import { render } from "./LogOutButton.vue?vue&type=template&id=357a81d6&scoped=true"
import script from "./LogOutButton.vue?vue&type=script&lang=js"
export * from "./LogOutButton.vue?vue&type=script&lang=js"

import "./LogOutButton.vue?vue&type=style&index=0&id=357a81d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-357a81d6"]])

export default __exports__